<template>
  <div class="has-text-left">
    <div v-if="form" class="columns">
      <div class="column">
        <div>
          <p><b>First Name</b></p>
          <input v-model="form.data.company_employee.fields.first_name.value" class="outlined" disabled>
        </div>
        <div>
          <p><b>Phone Number</b></p>
          <input v-model="form.data.company_employee.fields.phone_number.value" class="outlined" disabled>
        </div>
        <div v-if="payload.is_create">
          <p><b>Title</b></p>
          <input v-model="form.data.company_employee.fields.title.value" class="outlined" disabled>
        </div>
      </div>
      <div class="column">
        <div>
          <p><b>Last Name</b></p>
          <input v-model="form.data.company_employee.fields.last_name.value" class="outlined" disabled>
        </div>
        <div>
          <p><b>Email</b></p>
          <input v-model="form.data.company_employee.fields.email.value" class="outlined" disabled>
        </div>
      </div>
    </div>
    <div class="columns" v-show="false">
      <div class="column">
        <button @click="submit" class="button is-info" :disabled="is_loading">
          <span>Submit</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Validator from '@/custom/classes/validator.js'
export default {
  name: 'CompanyEmployeeForm',
  props: ['payload'],
  data () {
    return {
      validator: new Validator(),
      is_loading: false,
      isCreate: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getCompanyEmployees({ company_id: this.payload.company_id }).then(response => {
        console.log('Response', response)
        if (response.data.length === 0) {
          this.setForm({
            user: {
              first_name: '',
              last_name: '',
              email: '',
              phone_number: ''
            },
            title: '',
            id: null
          })
          this.isCreate = true
          return
        }
        this.setForm(response.data[0])
      })
    },
    setForm (form_data) {
      console.log('Red flag', this.isCreate)
      this.form = new this.$form({
        company_employee: {
          fields: {
            first_name: {
              value: form_data.user.first_name,
              has_error: false,
              validations: []
            },
            last_name: {
              value: form_data.user.last_name,
              has_error: false,
              validations: []
            },
            email: {
              value: form_data.user.email,
              has_error: false,
              validations: []
            },
            phone_number: {
              value: form_data.user.phone_number,
              has_error: false,
              validations: []
            },
            title: {
              value: form_data.title,
              has_error: false,
              validations: []
            },
            company_id: {
              value: this.payload.company_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            },
            user_id: {
              value: form_data.user.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.isCreate ? 'post' : 'put',
            url: this.isCreate ? '/company_employees/' : `/company_employees/${form_data.id}`,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      if (this.form.data.company_employee.fields.first_name.value.length == 0) {
        this.$utils.emit('show_toast', { text: 'שם פרטי חובה' })
        return
      }
      if (this.form.data.company_employee.fields.last_name.value.length == 0) {
        this.$utils.emit('show_toast', { text: 'שם משפחה חובה' })
        return
      }
      if (!this.validator.validateEmail({ value: this.form.data.company_employee.fields.email.value })) {
        this.$utils.emit('show_toast', { text: 'אימייל לא תקין' })
        return
      }
      if (this.form.data.company_employee.fields.title != undefined && this.form.data.company_employee.fields.title.value.length == 0) {
        this.$utils.emit('show_toast', { text: 'title חובה' })
        return
      }
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then(async (response) => {
        this.$utils.emit('show_toast', { text: 'משתמש נרשם בהצלחה' })
        // TODO: add create user call to bind the user to employee
        if (this.isCreate) {
          await this.$network_utils.postUser({
            first_name: this.form.data.company_employee.fields.first_name.value,
            last_name: this.form.data.company_employee.fields.last_name.value,
            phone_number: this.form.data.company_employee.fields.phone_number.value,
            email: this.form.data.company_employee.fields.email.value,
            resource_type: 'Company',
            resource_id: this.payload.company_id
          })
        } else {
          await this.$network_utils.updateUser({
            user_id: this.form.data.company_employee.fields.user_id.value,
            first_name: this.form.data.company_employee.fields.first_name.value,
            last_name: this.form.data.company_employee.fields.last_name.value,
            phone_number: this.form.data.company_employee.fields.phone_number.value,
            email: this.form.data.company_employee.fields.email.value
          })
        }
      }).catch(() => {
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה ' })
      }).finally(() => {
        this.is_loading = false
        this.isCreate = false
      })
    },
    ...mapMutations('modals', ['remove', 'create'])
  }
}
</script>
